import React from 'react';
import '../css/footer.css';

const Footer = () => {
  const year = new Date().getFullYear();
  return (
    <footer className="pos-footer">
      RCS ALL RIGHTS RESERVED - {year}
    </footer>
  );
};

export default Footer;
